import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	Flex,
	Box,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Textarea,
	Button,
} from "@chakra-ui/react";
import { ReactNode, useState } from "react";
import PenIcon from "../icons/PenIcon";

export type ValidationEvent = {
	data: {
		reason: string;
	};
};

export type AcceptWithReasonModalProps = {
	// Configuration
	title: string;
	icon: ReactNode;
	description: string | ReactNode;
	discardButtonText: string;
	validationButtonText: string;
	colorScheme?: string;
	// Actions
	onValidation?: (event: ValidationEvent) => void;
	// Modal
	isOpen: boolean;
	onClose: () => void;
};

const AcceptWithReasonModal = ({
	title,
	icon,
	description,
	colorScheme,
	discardButtonText,
	validationButtonText,
	isOpen,
	onClose,
	onValidation,
}: AcceptWithReasonModalProps) => {
	colorScheme = colorScheme ?? "brand";
	const [reason, setReason] = useState<string>("");
	const handleValidation = () => {
		if (onValidation) {
			onValidation({
				data: {
					reason,
				},
			});
		}
		onClose();
	};
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor={`${colorScheme}.100`}
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							{icon !== undefined && icon}
							{icon === undefined && (
								<PenIcon w="24px" h="24px" color="brand.700"></PenIcon>
							)}
						</Flex>
						<Box lineHeight="48px">{title}</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					{description !== undefined && description}
					<Textarea
						placeholder="Explication"
						value={reason}
						onChange={(evt) => setReason(evt.target.value)}
					></Textarea>
				</ModalBody>
				<ModalFooter>
					<Flex w="100%" gap={4}>
						<Button w="100%" variant="link" onClick={onClose}>
							{discardButtonText}
						</Button>
						<Button
							w="100%"
							colorScheme={colorScheme}
							onClick={handleValidation}
						>
							{validationButtonText}
						</Button>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default AcceptWithReasonModal;
